import { Component, Inject, ElementRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-edit-winmedia-dialog',
  templateUrl: './editWinmediaDialog.component.html',
  styleUrls: ['./editWinmediaDialog.component.scss']
})
export class EditWinmediaDialogComponent {

  inData;

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  proprieteCtrl = new UntypedFormControl();
  filteredProprietes: Observable<string[]>;
  proprietes: string[] = [];
  allProprietes: string[] = [];

  selectedMood3;

  @ViewChild('proprieteInput') proprieteInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon('cancel', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/cancel.svg'));
    console.log(data);
    this.inData = data;
    this.allProprietes = data.proprietes;
    this.proprietes = this.setProprietesAsArray(data.element.proprietes);
    this.selectedMood3 = data.element.mood3;
    this.filteredProprietes = this.proprieteCtrl.valueChanges.pipe(
      startWith(null),
      map((propriete: string | null) => propriete ? this._filter(propriete) : this.allProprietes.slice()));
  }

  setProprietesAsArray(val) {
    if (val && val.trim().length > 0) {
      const array = val.trim().split('//');
      if (array[0].indexOf('/') === 0) {
        array[0] = array[0].slice(1, array[0].length);
      }
      if (array[array.length - 1].lastIndexOf('/') === array[array.length - 1].length - 1) {
        array[array.length - 1] = array[array.length - 1].slice(0, array[array.length - 1].length - 1);
      }
      return array;
    } else {
      return [];
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim() && !this.proprietes.includes(value)) {
      this.proprietes.push(value.trim());
    }

    if (input) {
      input.value = '';
    }

    this.proprieteCtrl.setValue(null);
  }

  remove(propriete: string): void {
    const index = this.proprietes.indexOf(propriete);

    if (index >= 0) {
      this.proprietes.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.proprietes.includes(event.option.viewValue)) {
      this.proprietes.push(event.option.viewValue);
    }
    this.proprieteInput.nativeElement.value = '';
    this.proprieteCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allProprietes.filter(propriete => propriete.toLowerCase().indexOf(filterValue) === 0);
  }

  edit(bool, data = []) {
    let proprietesReturn = '';
    for (const prop of this.proprietes) {
      proprietesReturn += '/' + prop + '/';
    }
    this.dialogRef.close({
      change: bool,
      proprietesReturn: proprietesReturn,
      mood3Return: this.selectedMood3 ? this.selectedMood3 : ''
    });
  }

}
